import "./Navbar.style.css";
import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";

const TopNavbar = (props) => {
  const handleViewChange = (viewName) => {
    props.onChangePage("MainPage");
    props.onChangeView(viewName);
  };

  return (
    <Navbar className="navbar-distributed" expand="lg">
      <Container>
        <Navbar.Brand
          href="https://www.mittelstand-digital-wertnetzwerke.de/"
          target="_blank"
        >
          <img
            src="logo-mdz-wnw.png"
            alt="Logo Mittelstand Digital-Zentrum WertNetzWerke"
            id="Mittelstand-Logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <NavDropdown title="Kreislaufwirtschaft" id="basic-nav-dropdown">
              <NavDropdown.Item onClick={() => handleViewChange("Intro")}>
                Produktlebenszyklus
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleViewChange("EcoDesign")}>
                Eco-design
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleViewChange("Strategies")}>
                Strategien
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleViewChange("Partners")}>
                Partnerschaften
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleViewChange("AI")}>
                Künstliche Intelligenz
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link
              id="navbar-link"
              onClick={() => {
                props.onChangePage("MaterialPage");
              }}
            >
              Materialien
            </Nav.Link>
            <Nav.Link
              id="navbar-link"
              onClick={() => {
                props.onChangePage("AboutUsPage");
              }}
            >
              Über uns
            </Nav.Link>
            <Nav.Link
              id="navbar-link"
              onClick={() => {
                props.onChangePage("ContactPage");
              }}
              className="contact-link"
            >
              Kontakt
            </Nav.Link>
          </Nav>
          <Nav className="guide-label">Kreislaufwirtschafts-Guide</Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default TopNavbar;
